module.exports = __webpack_public_path__ + "img/male.441e769e.svg";